'use client';

import type { SchemaType } from '~/utils/schema';

export function Schema({ schema }: { schema: SchemaType }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
